// extracted by mini-css-extract-plugin
export default {"dropdown":"styles_dropdown__N6s7F","status":"styles_status__rCbI2","modal":"styles_modal__8eaU1","note":"styles_note__JifKq","rot":"styles_rot__lCitY"};